import { render, staticRenderFns } from "./ToothTreatmentServiceRow.vue?vue&type=template&id=322056ad&scoped=true&"
import script from "./ToothTreatmentServiceRow.vue?vue&type=script&lang=js&"
export * from "./ToothTreatmentServiceRow.vue?vue&type=script&lang=js&"
import style0 from "./ToothTreatmentServiceRow.vue?vue&type=style&index=0&id=322056ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322056ad",
  null
  
)

export default component.exports